import { render } from "./CurrentVehicleData.vue?vue&type=template&id=f745c1aa&scoped=true"
import script from "./CurrentVehicleData.vue?vue&type=script&lang=js"
export * from "./CurrentVehicleData.vue?vue&type=script&lang=js"

import "./CurrentVehicleData.vue?vue&type=style&index=0&id=f745c1aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f745c1aa"]])

export default __exports__